import React from 'react'
import './App.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import { IoAlertCircleOutline, IoInformationCircleOutline } from 'react-icons/io5'
import ClipLoader from 'react-spinners/ClipLoader'
import { BiMenu } from 'react-icons/bi'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'

// Match these to your SideNav CSS widths
const SIDEBAR_WIDTH = 240
const SIDEBAR_COLLAPSED_WIDTH = 72

const C = {
  ink: '#14213d',
  muted: '#6b7590',
  line: '#e6e9f2',
  track: '#eef1f8',
  blue: '#2f6fed',
  down: '#e5484d',
}

const EVENT_TYPES = [
  { label: 'Beauty pageant', value: 'beauty pageant' },
  { label: 'Fashion show', value: 'Fashion Show' },
  { label: 'Product launch', value: 'product launch' },
  { label: 'Baby shower', value: 'baby shower' },
  { label: 'Bachelor party', value: 'bachelor party' },
  { label: 'Birth day celebration', value: 'birth day celebration' },
  { label: 'Music festival', value: 'music festival' },
  { label: 'Food festival', value: 'food festival' },
  { label: 'Street party', value: 'street party' },
  { label: 'Festival', value: 'festival' },
  { label: 'PS5', value: 'PS5' },
  { label: 'Religious', value: 'religious' },
  { label: 'Music concert', value: 'music concert' },
  { label: 'Business gathering', value: 'business gathering' },
  { label: 'Networking', value: 'networking' },
  { label: 'Movie night', value: 'movie night' },
  { label: 'color frenzy', value: 'color frenzy' },
  { label: 'Culture and tradition', value: 'culture and tradition' },
  { label: 'Tea party', value: 'tea party' },
  { label: 'Team building', value: 'team building' },
  { label: 'Woman empowerment', value: 'woman empowerment' },
  { label: 'Man empowerment', value: 'man empowerment' },
  { label: 'Conference', value: 'conference' },
  { label: 'Other', value: 'other' },
]

const PROVINCES = [
  { label: 'Eastern Cape', value: 'eastern cape' },
  { label: 'Free State', value: 'free state' },
  { label: 'Gauteng', value: 'gauteng' },
  { label: 'KwaZulu-Natal', value: 'kwaZulu-natal' },
  { label: 'Limpopo', value: 'limpopo' },
  { label: 'Mpumalanga', value: 'mpumalanga' },
  { label: 'Northern Cape', value: 'northern cape' },
  { label: 'North West', value: 'north west' },
  { label: 'Western Cape', value: 'western cape' },
]

const styles = `
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');

.ae { font-family: 'Manrope', system-ui, -apple-system, 'Segoe UI', sans-serif; color: ${C.ink}; max-width: 760px; margin: 0 auto; padding: 8px 0 64px; }
.ae *, .ae *::before, .ae *::after { box-sizing: border-box; }
.ae h1, .ae h2, .ae p { margin: 0; }

.ae-back { display: inline-flex; align-items: center; gap: 4px; background: none; border: 0; padding: 4px 8px 4px 0; color: ${C.muted}; font: 600 14px/1 'Manrope', sans-serif; cursor: pointer; margin-top:40px }
.ae-back:hover { color: ${C.ink}; }
.ae-back:focus-visible { outline: 2px solid ${C.blue}; outline-offset: 2px; border-radius: 6px; }

.ae-head { margin: 14px 0 20px; }
.ae .ae-title { font-size: 26px; font-weight: 800; letter-spacing: -0.02em; line-height: 1.2; color: ${C.ink}; text-align: left; }
.ae .ae-sub { margin-top: 6px; font-size: 14px; font-weight: 500; color: ${C.muted}; }

.ae-card { background: #fff; border: 1px solid ${C.line}; border-radius: 14px; padding: 24px; margin-bottom: 16px; }
.ae-card-h { display: flex; align-items: center; gap: 10px; margin-bottom: 18px; }
.ae-step { width: 26px; height: 26px; border-radius: 50%; background: ${C.ink}; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 12.5px; font-weight: 800; }
.ae .ae-card-t { font-size: 16px; font-weight: 800; }

.ae-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px 18px; }
.ae-full { grid-column: 1 / -1; }

.ae-field label { display: block; margin: 0 0 6px; font-size: 13px; font-weight: 700; color: ${C.ink}; }
.ae-field label i { color: ${C.down}; font-style: normal; margin-left: 2px; }
.ae-hint { margin-top: 5px; font-size: 12px; color: ${C.muted}; font-weight: 500; }

.ae-input { width: 100%; height: 44px; padding: 0 14px; border: 1px solid #d5dae8; border-radius: 10px; background: #fff; color: ${C.ink}; font: 500 14.5px 'Manrope', sans-serif; transition: border-color .15s ease, box-shadow .15s ease; }
textarea.ae-input { height: auto; padding: 12px 14px; line-height: 1.55; resize: vertical; min-height: 120px; }
select.ae-input { appearance: none; -webkit-appearance: none; padding-right: 38px; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5l5 5 5-5' fill='none' stroke='%236b7590' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 14px center; }
.ae-input:hover { border-color: #b9c1d6; }
.ae-input:focus { outline: none; border-color: ${C.blue}; box-shadow: 0 0 0 3px rgba(47,111,237,.16); }
.ae-input::placeholder { color: #9aa3b8; }
.ae-input:invalid { box-shadow: none; }

.ae-note { display: flex; gap: 12px; padding: 14px 16px; border-radius: 12px; background: rgba(47,111,237,.07); border: 1px solid rgba(47,111,237,.22); font-size: 13.5px; line-height: 1.55; margin-bottom: 16px; }
.ae-note svg { flex: 0 0 auto; margin-top: 2px; color: ${C.blue}; }
.ae-note b { display: block; color: ${C.blue}; font-weight: 700; margin-bottom: 2px; }

.ae-err { display: flex; align-items: flex-start; gap: 10px; padding: 12px 16px; margin-bottom: 16px; border-radius: 12px; background: rgba(229,72,77,.08); border: 1px solid rgba(229,72,77,.3); color: #b3282d; font-size: 14px; font-weight: 600; cursor: pointer; }
.ae-err svg { flex: 0 0 auto; margin-top: 1px; }

.ae-actions { display: flex; justify-content: flex-end; }
.ae-btn { min-width: 140px; height: 46px; padding: 0 26px; display: inline-flex; align-items: center; justify-content: center; border: 0; border-radius: 10px; background: ${C.ink}; color: #fff; font: 700 15px 'Manrope', sans-serif; cursor: pointer; transition: background .15s ease; }
.ae-btn:hover:not(:disabled) { background: #1f3260; }
.ae-btn:disabled { opacity: .6; cursor: not-allowed; }
.ae-btn:focus-visible { outline: 2px solid ${C.blue}; outline-offset: 2px; }

@media (max-width: 640px) {
  .ae-grid { grid-template-columns: 1fr; }
  .ae-card { padding: 18px; }
  .ae .ae-title { font-size: 22px; }
  .ae-actions .ae-btn { width: 100%; }
}
`

const Field = ({ label, required, hint, full, children }) => (
  <div className={`ae-field ${full ? 'ae-full' : ''}`}>
    <label>
      {label}
      {required ? <i>*</i> : null}
    </label>
    {children}
    {hint ? <div className="ae-hint">{hint}</div> : null}
  </div>
)

class Addevent extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    const businessName = localStorage.getItem('businessname')
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      successError: '',
      errorDisplay: 'none',
      businessname: businessName,
      eventname: '',
      customOrganiserName: businessName,
      eventdate: '',
      eventid: '',
      poster: '',
      theme: 'N/A',
      venue: '',
      expectednum: '',
      enddate: '',
      time: '',
      endtime: '',
      event_date: '',
      finish_date: '',
      description: '',
      spinning: 'none',
      updateDisplay: 'block',
      eventtype: '',
      provinces: '',
      createBtn: 'save-btn',
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    document.title = 'Add new event / Karamale '
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  handleEventname = (event) => {
    this.setState({ eventname: event.target.value, errorDisplay: 'none' })
  }

  handleOrganiserName = (event) => {
    this.setState({
      customOrganiserName: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleVenue = (event) => {
    this.setState({
      venue: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTheme = (event) => {
    this.setState({
      theme: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleExpected = (event) => {
    this.setState({
      expectednum: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleDate = (event) => {
    this.setState({
      event_date: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleEnddate = (event) => {
    this.setState({
      finish_date: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleTime = (event) => {
    this.setState({
      time: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleEndtime = (event) => {
    this.setState({
      endtime: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleDescription = (event) => {
    this.setState({
      description: event.target.value,
      errorDisplay: 'none',
    })
  }

  handleChange = (e) => {
    this.setState({ eventtype: e.target.value })
  }

  handleProvinces = (e) => {
    this.setState({ provinces: e.target.value })
  }

  update = () => {
    setTimeout(() => {
      this.setState({ errorDisplay: 'none' })
    }, 5000)
    const businessid = localStorage.getItem('businessid')
    const eventname = this.state.eventname
    const customOrganiserName = this.state.customOrganiserName
    const venue = this.state.venue
    const theme = this.state.theme
    const expectednum = this.state.expectednum
    const time = this.state.time
    const endtime = this.state.endtime
    const description = this.state.description
    const finish_date = this.state.finish_date
    const event_date = this.state.event_date
    const eventtype = this.state.eventtype
    const province = this.state.provinces

    const fail = (message) =>
      this.setState({
        error: message,
        errorDisplay: 'block',
        successError: 'error-login',
        updateDisplay: 'block',
        spinning: 'none',
      })

    if (eventtype === '') {
      fail('Please select event type')
    } else if (province === '') {
      fail('Please select the hosting province')
    } else if (this.state.eventname.trim() === '') {
      fail('Please enter event name')
    } else if (this.state.venue.trim() === '') {
      fail('Please enter venue')
    } else if (theme.trim() === '') {
      fail('Please enter a theme')
    } else if (this.state.expectednum.trim() === '') {
      fail('Enter estimated Number of Attendees')
    } else if (event_date === '') {
      fail('Enter the event date')
    } else if (finish_date === '') {
      fail('Enter the event end date')
    } else if (this.state.time.trim() === '') {
      fail('Enter event time')
    } else if (this.state.endtime.trim() === '') {
      fail('Enter event end time')
    } else if (this.state.description.trim() === '') {
      fail('Enter description')
    } else {
      this.setState({
        createBtn: 'btn-disabled',
        spinning: 'block',
        updateDisplay: 'none',
      })
      const data = new FormData()
      data.append('query', 'ADDEVENT')
      data.append('subquery', 'ADDEVENT')
      data.append('visa', '1')
      data.append('cash', '0')
      data.append('accountid', businessid)
      data.append('event', eventname)
      data.append('customOrganiserName', customOrganiserName)
      data.append('venue', venue)
      data.append('theme', theme)
      data.append('expected', expectednum)
      data.append('startdate', event_date)
      data.append('enddate', finish_date)
      data.append('starttime', time)
      data.append('endtime', endtime)
      data.append('description', description)
      data.append('eventtype', eventtype)
      data.append('province', province)

      Axios({
        method: 'post',
        url: `${API_URL}/apps/kscanner/webservices.php`,
        data: data,
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          console.log(response.data.status)
          if (response.data.status === 'success') {
            this.props.history.push('/dashboard')
          } else {
            this.setState({
              error: response.data.message,
              errorDisplay: 'block',
              successError: 'error-login',
              createBtn: 'save-btn',
              spinning: 'none',
              updateDisplay: 'block',
            })
          }
          console.log('Event created:', response.data.message)
        })
        .catch((error) => {
          this.setState({
            error: error.response?.data || error.message,
            errorDisplay: 'block',
            successError: 'error-login',
            createBtn: 'save-btn',
            spinning: 'none',
            updateDisplay: 'block',
          })
          console.error('Error creating event:', error.response?.data || error.message)
        })
    }
  }

  close = () => {
    this.setState({ errorDisplay: 'none' })
  }

  render() {
    if (localStorage.getItem('businessname') === null) {
      return <Redirect to="/login" />
    }
    const { eventtype, provinces, collapsed, isMobile } = this.state
    const today = new Date().toISOString().split('T')[0]
    const accounttype = localStorage.getItem('accounttype')
    const busy = this.state.spinning === 'block'

    const hasSidebar = accounttype === 'customer' || accounttype === 'business'
    const sidebarOffset =
      !hasSidebar || isMobile ? 0 : collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH

    return (
      <div className="view">
        <style>{styles}</style>

        {accounttype === 'customer' ? (
          <>
            <SideNavCust collapsed={collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={collapsed} onToggle={this.handleToggle} />
            <Header />
          </>
        ) : (
          <Header5 />
        )}

        {hasSidebar && isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}
        {hasSidebar && isMobile && collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <div
          style={{
            marginTop: 48,
            marginLeft: sidebarOffset,
            width: `calc(100% - ${sidebarOffset}px)`,
            padding: '0 16px',
            transition: 'margin-left .25s ease, width .25s ease',
          }}
        >
          <div className="ae">
            <button type="button" className="ae-back" onClick={() => this.props.history.goBack()}>
              <IoIosArrowBack size={18} />
              Back
            </button>

            <div className="ae-head">
              <h1 className="ae-title">Create an event</h1>
              <p className="ae-sub">
                Fill in the details below and start selling tickets right away.
              </p>
            </div>

            {/* 1 - Basics */}
            <div className="ae-card">
              <div className="ae-card-h">
                <span className="ae-step">1</span>
                <h2 className="ae-card-t">Event basics</h2>
              </div>
              <div className="ae-grid">
                <Field label="What kind of event will this be?" required>
                  <select value={eventtype} onChange={this.handleChange} className="ae-input">
                    <option value="" disabled>
                      Select event type
                    </option>
                    {EVENT_TYPES.map((obj) => (
                      <option key={obj.value} value={obj.value}>
                        {obj.label}
                      </option>
                    ))}
                  </select>
                </Field>

                <Field label="Hosting province" required>
                  <select value={provinces} onChange={this.handleProvinces} className="ae-input">
                    <option value="" disabled>
                      Select province
                    </option>
                    {PROVINCES.map((obj) => (
                      <option key={obj.value} value={obj.value}>
                        {obj.label}
                      </option>
                    ))}
                  </select>
                </Field>

                <Field label="Event name" required full>
                  <input
                    type="text"
                    value={this.state.eventname}
                    onChange={this.handleEventname}
                    className="ae-input"
                  />
                </Field>

                <Field
                  label="Organizer name"
                  hint="If left empty, it defaults to your account name."
                  full
                >
                  <input
                    type="text"
                    placeholder="If not set, defaults to account name"
                    value={this.state.customOrganiserName}
                    onChange={this.handleOrganiserName}
                    className="ae-input"
                  />
                </Field>
              </div>
            </div>

            {/* 2 - Venue */}
            <div className="ae-card">
              <div className="ae-card-h">
                <span className="ae-step">2</span>
                <h2 className="ae-card-t">Venue and audience</h2>
              </div>
              <div className="ae-grid">
                <Field label="Venue" required full>
                  <input
                    type="text"
                    value={this.state.venue}
                    onChange={this.handleVenue}
                    className="ae-input"
                  />
                </Field>

                <Field label="Theme" required>
                  <input
                    type="text"
                    value={this.state.theme}
                    onChange={this.handleTheme}
                    className="ae-input"
                  />
                </Field>

                <Field label="Estimated number of attendees" required>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={this.state.expectednum}
                    onChange={this.handleExpected}
                    className="ae-input"
                  />
                </Field>
              </div>
            </div>

            {/* 3 - Date and time */}
            <div className="ae-card">
              <div className="ae-card-h">
                <span className="ae-step">3</span>
                <h2 className="ae-card-t">Date and time</h2>
              </div>
              <div className="ae-grid">
                <Field label="Start date" required>
                  <input
                    type="date"
                    value={this.state.event_date}
                    min={today}
                    onChange={this.handleDate}
                    className="ae-input"
                  />
                </Field>

                <Field label="End date" required>
                  <input
                    type="date"
                    value={this.state.finish_date}
                    min={this.state.event_date !== '' ? this.state.event_date : today}
                    onChange={this.handleEnddate}
                    className="ae-input"
                  />
                </Field>

                <Field label="Start time" required>
                  <input
                    type="time"
                    value={this.state.time}
                    onChange={this.handleTime}
                    className="ae-input"
                  />
                </Field>

                <Field label="End time" required>
                  <input
                    type="time"
                    value={this.state.endtime}
                    onChange={this.handleEndtime}
                    className="ae-input"
                  />
                </Field>
              </div>
            </div>

            {/* 4 - Description */}
            <div className="ae-card">
              <div className="ae-card-h">
                <span className="ae-step">4</span>
                <h2 className="ae-card-t">Description</h2>
              </div>
              <Field label="Tell people what to expect" required>
                <textarea
                  value={this.state.description}
                  onChange={this.handleDescription}
                  className="ae-input"
                  rows={5}
                />
              </Field>
            </div>

            <div className="ae-note">
              <IoInformationCircleOutline size={20} />
              <div>
                <b>Refunds are off by default</b>
                If you'd like to allow ticket buyers to request refunds, you can enable this in the
                Edit Event screen before ticket sales begin.
              </div>
            </div>

            {this.state.errorDisplay === 'block' && this.state.error ? (
              <div className="ae-err" role="alert" onClick={() => this.close()}>
                <IoAlertCircleOutline size={20} />
                <span>{String(this.state.error)}</span>
              </div>
            ) : null}

            <div className="ae-actions">
              <button
                type="button"
                className="ae-btn"
                onClick={() => this.update()}
                disabled={busy}
              >
                {busy ? <ClipLoader color={'#ffffff'} loading={true} size={20} /> : 'Create event'}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Addevent
